import { Theme, createStyles } from '@zn-material-ui'

export default ({ palette }: Theme) =>
  createStyles({
    paper: {
      paddingBottom: 50,
      paddingTop: 70,
      width: 570,
      backgroundColor: '#fff',
      borderRadius: 4,
      '&:focus': {
        backgroundColor: '#fff !important', // IE 兼容
      },
    },
    closeButton: {
      position: 'absolute',
      right: 23,
      top: 23,
      padding: 0,
      color: '#999999',
      '&:hover': {
        background: 'none',
      },
    },
    dialogFooterBtn: {
      display: 'flex',
      justifyContent: 'center',
      height: 48,
      width: '100%',
      marginTop: '20px',
      '& button': {
        width: 170,
        height: '100%',
        fontSize: 18,
      },
    },
    noBtn: {
      color: palette.primary.main,
      backgroundColor: palette.secondary.main,
      border: `1px solid ${palette.primary.main}`,
      marginRight: 40,
      '&:hover': {
        color: palette.primary.main,
        backgroundColor: palette.secondary.main,
        border: `1px solid ${palette.primary.main}`,
      },
    },
  })
